import { AfterViewInit, ChangeDetectionStrategy, ChangeDetectorRef, Component, EventEmitter, Input, OnInit, Output, SimpleChange, SimpleChanges, ViewChild, ViewEncapsulation } from '@angular/core';
import { OneWebComponentsAngularModule } from '@one/angular';
import { AddOwnTemplateDialogComponent } from '../../add-own-template-dialog/add-own-template-dialog.component';
import { Subject } from 'rxjs';
import { QnSbnDataServiceService } from '../../../services/qn-sbn-data-service.service';
import { MessageAttachmentTemplateComponent } from '../message-attachment-template/message-attachment-template.component';
import { FormsModule } from '@angular/forms';
import { NgIf } from '@angular/common';

interface MessageTemplate {
  templateId: string;
  templateDetails: {
    templateSubject: string;
    templateBody: string;
  };
  [key: string]: any;
}

interface MessageTemplateData {
  tableData: MessageTemplate[];
  columnData: string[];
}

@Component({
  selector: 'dl-message-attachment-template-dialog',
  standalone: true,
  imports: [OneWebComponentsAngularModule, MessageAttachmentTemplateComponent, AddOwnTemplateDialogComponent, FormsModule],
  templateUrl: './message-attachment-template-dialog.component.html',
  styleUrl: './message-attachment-template-dialog.component.scss',
  encapsulation: ViewEncapsulation.None,
  changeDetection: ChangeDetectionStrategy.OnPush,
  providers: [AddOwnTemplateDialogComponent]
})
export class MessageAttachmentTemplateDialogComponent implements OnInit, AfterViewInit {
  @ViewChild(MessageAttachmentTemplateComponent) messageTemplateComponent: MessageAttachmentTemplateComponent;
  public isTemplateDialogVisible = false;
  public backdropProps = { class: 'backdrop' };
  public templateColumn: any;
  public templateData: any;
  public newMessageTemplate: Subject<any> = new Subject<any>();
  public isAffBtnDisabled = true;
  public isNtBtnDisabled = false;
  public isNewFromTemplate = true;
  public selectedRow: any = null;
  @Input() inputData: any;
  @Output() templateSelected = new EventEmitter<any>();
  @Output() closeDialog = new EventEmitter<any>();
  isVisible: boolean;
  handleModalChange: any;
  public data = {}
  visibleTemplate: boolean = false;
  public constructor(private changeDetectorRef: ChangeDetectorRef, private _QnSbnDataService: QnSbnDataServiceService, private addOwnTemplateDialogComponent: AddOwnTemplateDialogComponent) { }

  ngOnChanges(changes: SimpleChanges) {
    if (changes['inputData'] && changes['inputData'].currentValue) {
      const data = changes['inputData'].currentValue;
      this.templateColumn = data.columnData;
      this.templateData = data.tableData;
      // Clear selection when dialog opens
      this.selectedRow = [];
      this.isAffBtnDisabled = true;
      this.isNtBtnDisabled = false;

      // Use setTimeout to ensure child component is fully initialized
      setTimeout(() => {
        if (this.messageTemplateComponent) {
          this.messageTemplateComponent.clearSelection();
        }
        this.changeDetectorRef.detectChanges();
      }, 0);
    }
  }

  ngAfterViewInit(): void {
    // Clear selection when view is initialized
    if (this.messageTemplateComponent) {
      this.messageTemplateComponent.clearSelection();
    }
  }



  public ngOnInit(): void {
  }

  public addTemplateToForm(): void {
    const newData = {
      newColumnData: ['dragHandle', 'selectText', 'messageTemplate', 'iconSets'],
      newTableData: [this.selectedRow]
    };
    this.closeDialog.emit({ data: newData });
    this.changeDetectorRef.detectChanges();
    
    // Get template details - handle both flat and nested structures
    const templateDetails = this.selectedRow?.templateDetails || this.selectedRow;
    this._QnSbnDataService.getMappedQnsbnData({
      "subjectName": templateDetails?.templateSubject || "",
      "messageAttachmentRTEText": templateDetails?.templateBody || "",
      "templateId": this.selectedRow?.templateId || ""
    }, "MessageAttachment");
  }

  public getSelectedRowInTemplate(rows: any): void {


    if (Array.isArray(rows.messageSelected)) {
      this.selectedRow = rows.messageSelected[0] ?? null;
    } else {
      this.selectedRow = rows.messageSelected;
    }

    const isSelected = !!this.selectedRow;
    this.isAffBtnDisabled = !isSelected;
    this.isNtBtnDisabled = isSelected;
  }


  public openNewTemplateAction(): void {
    this.data =
    {
      tableData: [], columnData: [],
      allTemplates: this.templateData,
      messageType: 'Email'
    }
    this.visibleTemplate = true;
    this.changeDetectorRef.detectChanges();
  }

}
